import React from "react";

import svg from "../../assets/images/icons/EditStack/light.svg";

export const EditStackLightIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Edit"}
    />
);
